// boost-gift: auto-add/remove free gift + cart-drawer banner.
// Talks to the Shopify App Proxy → mizziburlo Helpdesk app.
//
// A rename of the proxy subpath (boost-gift -> mizziburlo-apps) was staged and
// then parked: Shopify accepted the app config but the storefront never routed
// the new subpath. Both are tried, live one first, and whichever answers is
// pinned for the session — so if the rename is ever completed this file needs
// no change, and today it costs no extra request.
(function () {
  var PROXY_PATHS = ['/apps/boost-gift', '/apps/mizziburlo-apps'];

  // ---- Promo-code capture (code-gated campaigns) --------------------------
  // Shopify keeps the pending checkout code inside an HttpOnly cookie, so the
  // storefront can't read it back. Instead the promo link carries the code as
  // ?discount=CODE: we remember it, arm Shopify's checkout cookie ourselves by
  // hitting /discount/CODE in the background, and send it with each state
  // call so the server can confirm this visitor is a code-holder. Only then
  // does the gift auto-add resume — everyone else never sees the shaker.
  var CODE_KEY = 'boost_gift_code';

  function capturePromoCode() {
    try {
      var param = new URLSearchParams(window.location.search).get('discount');
      if (!param) return;
      localStorage.setItem(CODE_KEY, param.toUpperCase());
      // Fire-and-forget: the redirect response sets the checkout cookie.
      fetch('/discount/' + encodeURIComponent(param), { credentials: 'same-origin' }).catch(function () {});
    } catch (e) {
      /* storage denied — the customer can still type the code at checkout */
    }
  }

  function promoCode() {
    try { return localStorage.getItem(CODE_KEY) || ''; } catch (e) { return ''; }
  }

  capturePromoCode();
  var proxyBase = null; // pinned to the first path that answers

  function stateUrl(base, query) { return base + '/state' + query; }

  // Resolve against each candidate in turn. A 404 means "wrong subpath, try
  // the next one"; anything else (including a network error) is a real
  // failure and is surfaced to the caller.
  function fetchState_(query) {
    var bases = proxyBase ? [proxyBase] : PROXY_PATHS.slice();
    var i = 0;
    function attempt() {
      var base = bases[i];
      return fetch(stateUrl(base, query), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (r.status === 404 && i < bases.length - 1) { i++; return attempt(); }
          if (!r.ok) throw new Error('proxy ' + r.status);
          proxyBase = base;
          return r.json();
        });
    }
    return attempt();
  }
  var inFlight = false;
  var attempted = {}; // gift variant -> already tried adding this page view
  var giftMutationInFlight = false; // set while addGift/removeGift is calling /cart/*.js

  function gid(productOrVariantId) {
    if (!productOrVariantId) return '';
    // Shopify cart.js gives numeric IDs; we need GID format ("gid://shopify/ProductVariant/...")
    return 'gid://shopify/' + productOrVariantId;
  }

  function variantGid(id) { return 'gid://shopify/ProductVariant/' + id; }
  function productGid(id) { return 'gid://shopify/Product/' + id; }

  function fetchCart() {
    // Cache-buster: Shopify + Appstle can occasionally serve a stale cart for a
    // few hundred ms after /cart/add.js resolves. This forces a fresh read.
    return fetch('/cart.js?_ts=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function fetchState(cart) {
    // Judge conditions on what the customer chose to buy: exclude the gift
    // line WE added (stamped _boost_gift). Otherwise a buy-2-get-1 on the
    // same product would count its own free unit toward the trigger, and the
    // gift's list price would inflate the subtotal check.
    var paidItems = (cart.items || []).filter(function (i) {
      return !(i.properties && i.properties._boost_gift);
    });
    var subtotalCents = paidItems.reduce(function (sum, i) {
      return sum + (i.final_line_price != null ? i.final_line_price : i.line_price || 0);
    }, 0);
    var productIds = paidItems.map(function (i) { return productGid(i.product_id); });
    var variantIds = paidItems.map(function (i) { return variantGid(i.variant_id); });
    var quantities = paidItems.map(function (i) { return i.quantity || 1; });
    var query =
      '?subtotal_cents=' + encodeURIComponent(subtotalCents) +
      '&product_ids=' + encodeURIComponent(productIds.join(',')) +
      '&variant_ids=' + encodeURIComponent(variantIds.join(',')) +
      '&quantities=' + encodeURIComponent(quantities.join(',')) +
      '&_ts=' + Date.now();
    var code = promoCode();
    if (code) query += '&code=' + encodeURIComponent(code);
    return fetchState_(query);
  }

  function cartSectionIds() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  // FormData add — JSON with `sections` gets rejected 422 by Shopify. This is
  // the same pattern product-form.js uses; the response comes back with the
  // pre-rendered drawer + badge HTML we can hand to renderContents().
  function addGift(variantGidStr) {
    var idMatch = variantGidStr.match(/ProductVariant\/(\d+)$/);
    if (!idMatch) return Promise.resolve();
    var variantId = idMatch[1];
    var fd = new FormData();
    fd.append('items[0][id]', variantId);
    fd.append('items[0][quantity]', 1);
    fd.append('items[0][properties][_boost_gift]', 'true');
    fd.append('sections', cartSectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    giftMutationInFlight = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: fd
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (v) { giftMutationInFlight = false; return v; });
  }

  // Hydrate the cart-drawer's deferred <template> if the drawer hasn't been
  // opened yet — otherwise .drawer__inner doesn't exist and both reload() and
  // renderContents() throw on `null.classList`.
  function hydrateCartDrawer(drawer) {
    if (drawer.querySelector('.drawer__inner')) return true;
    var tpl = drawer.querySelector('template.deferred');
    if (tpl && typeof window.loadTemplateContent === 'function') {
      window.loadTemplateContent(drawer);
    } else if (tpl && tpl.content) {
      var frag = tpl.content.cloneNode(true);
      tpl.parentNode.insertBefore(frag, tpl);
      tpl.remove();
    }
    return !!drawer.querySelector('.drawer__inner');
  }

  // Refresh the theme's drawer + badge from a /cart/add.js response that already
  // contains pre-rendered sections. Falls back to drawer.reload() if the response
  // is null (e.g. add succeeded server-side but we lost the body).
  function refreshDrawer(response) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { console.warn('[boost-gift] no cart-drawer element'); return; }
    var hydrated = hydrateCartDrawer(drawer);
    drawer.classList.remove('is-empty');
    var items = drawer.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
    if (!hydrated) return;
    try {
      if (response && response.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections: response.sections }, true);
      } else if (typeof drawer.reload === 'function') {
        drawer.reload();
      }
    } catch (e) {
      console.warn('[boost-gift] drawer refresh failed:', e);
    }
  }

  // Only lines we added carry the `_boost_gift` property. A manual add of the
  // same variant (customer bought the gift product at full price) is left alone.
  function findOurGiftLine(variantGidStr, cart) {
    var idMatch = variantGidStr.match(/ProductVariant\/(\d+)$/);
    if (!idMatch) return null;
    var variantId = Number(idMatch[1]);
    return (cart.items || []).find(function (i) {
      return i.variant_id === variantId && i.properties && i.properties._boost_gift;
    }) || null;
  }

  function removeGift(variantGidStr, cart) {
    var line = findOurGiftLine(variantGidStr, cart);
    if (!line) return Promise.resolve();
    giftMutationInFlight = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: line.key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .catch(function () {})
      .then(function () { giftMutationInFlight = false; });
  }

  // Banner removed per merchant request. Also strip any stale banners left
  // in the DOM from a previous version (e.g. re-rendered from cached HTML).
  function renderBanner() {
    document.querySelectorAll('.boost-gift-banner').forEach(function (el) { el.remove(); });
  }

  function flagGiftLineItems() {
    // Walk every line item in any cart UI; if it has the _boost_gift property, badge it
    var lineItems = document.querySelectorAll('[data-cart-item], .cart-item, .cart-drawer__item, .cart-drawer-redesign__row');
    lineItems.forEach(function (item) {
      if (item.dataset.boostGiftFlagged) return;
      // Look for a hidden indicator: the theme often renders properties as small text containing "_boost_gift"
      var propsText = item.textContent || '';
      if (propsText.indexOf('_boost_gift') === -1 && !item.querySelector('[data-boost-gift-line]')) return;
      var titleEl = item.querySelector('.cart-item__name, .cart-drawer__name, [data-cart-item-title], h3, h4');
      if (titleEl && !titleEl.querySelector('.boost-gift-line-flag')) {
        var flag = document.createElement('span');
        flag.className = 'boost-gift-line-flag';
        flag.textContent = 'Free';
        titleEl.appendChild(flag);
      }
      item.dataset.boostGiftFlagged = '1';
    });
  }

  function tick() {
    if (inFlight) return;
    inFlight = true;
    fetchCart()
      .then(function (cart) {
        return fetchState(cart).then(function (state) {
          renderBanner(state);
          flagGiftLineItems();

          if (!state || !state.active) { inFlight = false; return; }

          // Code-gated campaign: auto-add only for visitors the server has
          // confirmed hold the code (captured from the promo link). For them
          // checkout applies the code from the cookie their visit set, so the
          // gift really is free. Everyone else never sees it.
          if (state.requires_code && !state.code_ok) { inFlight = false; return; }

          // One entry per gift: the main gift plus any spend tiers (older
          // app versions send only the single-gift fields). Tiers stack, so
          // each is added or removed on its own threshold. Only lines WE
          // stamped with `_boost_gift` count; a customer's own add of the
          // same product is left alone.
          var tiers = (state.tiers && state.tiers.length)
            ? state.tiers
            : [{ gift_variant_id: state.gift_variant_id, qualifies: state.qualifies }];
          var lastAddResponse = null;
          var removed = false;
          var changed = false;
          var chain = Promise.resolve();
          tiers.forEach(function (t) {
            chain = chain.then(function () {
              var ours = findOurGiftLine(t.gift_variant_id, cart);
              if (t.qualifies && !ours) {
                // Tried once already this page (e.g. out of stock): don't loop.
                if (attempted[t.gift_variant_id]) return;
                attempted[t.gift_variant_id] = true;
                changed = true;
                return addGift(t.gift_variant_id).then(function (response) {
                  if (response) lastAddResponse = response;
                });
              }
              if (!t.qualifies) {
                delete attempted[t.gift_variant_id];
                if (ours) {
                  changed = true;
                  removed = true;
                  return removeGift(t.gift_variant_id, cart);
                }
              }
            });
          });
          return chain.then(function () {
            if (!changed) return;
            // An add response carries the re-rendered drawer; after a removal
            // it's stale, so reload instead.
            refreshDrawer(removed ? null : lastAddResponse);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              return fetchCart().then(function (newCart) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'boost-gift', cartData: newCart });
              });
            }
          });
        });
      })
      .catch(function () {})
      .then(function () { inFlight = false; });
  }

  // Schedule an immediate tick + a delayed follow-up. Handles the race where
  // /cart.js still reflects the pre-add state for a few hundred ms after
  // /cart/add.js resolves. The inFlight guard collapses concurrent ticks.
  function tickWithRetry() {
    tick();
    setTimeout(tick, 800);
  }

  // ---- fetch wrapper: detect ANY /cart/(add|change|update).js call and tick after ----
  // The theme's PUB_SUB_EVENTS.cartUpdate is unreliable here — pubsub.js may load
  // after this script, and if `subscribe` is undefined at init time we'd silently
  // skip event registration. Wrapping fetch is theme-agnostic and always fires.
  var CART_MUT_RE = /\/cart\/(add|change|update|clear)(?:\.js|\.json|$)/i;
  (function wrapFetch() {
    if (!window.fetch || window.__boostGiftFetchWrapped) return;
    window.__boostGiftFetchWrapped = true;
    var orig = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isMut = CART_MUT_RE.test(url) && String(method).toUpperCase() === 'POST';
      // Don't loop on our own gift-add/remove — we already tick after they resolve
      // (and the tick after those would just see our just-applied state and no-op).
      var isOurs = isMut && giftMutationInFlight;
      var p = orig(input, init);
      if (isMut && !isOurs) {
        p.then(function (res) { if (res && res.ok) tickWithRetry(); }).catch(function () {});
      }
      return p;
    };
  })();

  function init() {
    // Belt-and-suspenders: also subscribe if the theme's pubsub happens to be ready.
    // If it isn't, the fetch wrapper above still catches every /cart/*.js mutation.
    if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'boost-gift') return;
        tickWithRetry();
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[aria-controls="CartDrawer"], .cart-link, a[href="/cart"]')) {
        setTimeout(tick, 250);
      }
    });
    setTimeout(tick, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
